import { Doughnut } from "react-chartjs-2";
import { useTranslation } from "react-i18next";

// 성별 분포 그래프
const GenderGraph = ({ flexCol, graphData, options, data }) => {
  const { t } = useTranslation();
  return (
    <>
      <p className="flex font-extrabold text-[18px] ">{t('Admin_Dashboard_genderDistribution', '성별 분포')}</p>
      <div className="flex justify-between items-end w-full h-full">
        <div
          className="flex aspect-square w-full min-w-[160px] mr-6"
          style={{ maxWidth: flexCol ? "160px" : "240px" }} // flexCol일 경우에 그래프 최대크기는 160px
        >
          <Doughnut data={graphData} options={options} />
        </div>
        <div className="flex flex-col justify-end items-end h-full gap-y-3 text-[#020A1B]">
          <div className="flex justify-between w-[82px] text-base leading-[22px]">
            <p className="text-[#8EA0FF] mr-1">
              ●<span className="text-[#020A1B] ml-1">{t('Admin_Dashboard_male', '남')}</span>
            </p>
            <p className="font-semibold">{t('Admin_Dashboard_personCount', '{{count}}명', { count: data[0].male })}</p>
          </div>
          <div className="flex justify-between w-[82px] text-base leading-[22px]">
            <p className="text-[#FFBBBB] mr-1">
              ●<span className="text-[#020A1B] ml-1">{t('Admin_Dashboard_female', '여')}</span>
            </p>
            <p className="font-semibold">{t('Admin_Dashboard_personCount', '{{count}}명', { count: data[0].female })}</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default GenderGraph;
